import createIcon from '../../createIcon';

/**
 * @component @name ViewModule
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNjcgNVYxMS41SDkuMzNWNUgxNC42N1pNMTUuNjcgMTEuNUgyMVY1SDE1LjY3VjExLjVaTTE0LjY3IDE5VjEyLjVIOS4zM1YxOUgxNC42N1pNMTUuNjcgMTIuNVYxOUgyMVYxMi41SDE1LjY3Wk04LjMzIDEyLjVIM1YxOUg4LjMzVjEyLjVaTTguMzMgMTEuNVY1SDNWMTEuNUg4LjMzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ViewModule = createIcon('ViewModule', [
  [
    'path',
    {
      d: 'M14.67 5V11.5H9.33V5H14.67ZM15.67 11.5H21V5H15.67V11.5ZM14.67 19V12.5H9.33V19H14.67ZM15.67 12.5V19H21V12.5H15.67ZM8.33 12.5H3V19H8.33V12.5ZM8.33 11.5V5H3V11.5H8.33Z',
      key: 'v6uzlz',
    },
  ],
]);

export default ViewModule;
